<template>
  <div class="energy-statistics">
    <div class="title">用能统计(电)</div>
    <div class="query-condition">
      <div class="condition-row">
        <div class="label">建筑</div>
        <el-select v-model="buildingData" clearable placeholder="请选择" @change="queryData">
          <el-option v-for="item in buildingArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="condition-row" v-if="showChart">
        <div class="label">日期</div>
        <div>
          <el-date-picker v-model="dayDate" type="date" value-format="yyyy-MM-dd" :clearable="clearFlag"
            @change="queryData" placeholder="选择日期"></el-date-picker>
        </div>
      </div>
      <div class="condition-row" v-if="!showChart">
        <div class="label">日期</div>
        <el-select v-model="dateType" placeholder="请选择" @change="typeChange">
          <el-option v-for="item in dateTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div v-if="dateType == '0'">
          <el-date-picker v-model="dayDate" type="date" value-format="yyyy-MM-dd" :clearable="clearFlag"
            @change="queryData" placeholder="选择日期"></el-date-picker>
        </div>
        <div v-if="dateType == '1'">
          <el-date-picker v-model="dayDate" type="month" value-format="yyyy-MM" :clearable="clearFlag" @change="queryData"
            placeholder="选择月份"></el-date-picker>
        </div>
        <div v-if="dateType == '2'">
          <el-date-picker v-model="dayDate" type="year" value-format="yyyy" :clearable="clearFlag" @change="queryData"
            placeholder="选择年份"></el-date-picker>
        </div>
      </div>
      <div class="condition-row">
        <div id="show-text" style="margin: 0 10px; cursor: pointer;" @click="changeBox">
          <div v-if="showChart">
            <img src="../img/list.png" alt="" width="30" height="30">
          </div>
          <div v-else>
            <img src="../img/chart.png" alt="" width="30" height="30">
          </div>
        </div>
      </div>
    </div>
    <div class="chart-box">
      <div class="chart-container" v-if="showChart">
        <div class="part">
          <div class="total-row">
            <div class="label">当日用电：{{ dayElectricityUse }}</div>
            <div class="unit">kwh</div>
          </div>
          <div class="chart-row">
            <ElectricityHistogram ref="dayChart" :chartId="dayChart" :chartData="dayData"></ElectricityHistogram>
          </div>
        </div>
        <div class="part">
          <div class="total-row">
            <div class="label">当月用电：{{ monthElectricityUse }}</div>
            <div class="unit">kwh</div>
          </div>
          <div class="chart-row">
            <ElectricityHistogram :chartId="monthChart" :chartData="monthData"></ElectricityHistogram>
          </div>
        </div>
        <div class="part">
          <div class="total-row">
            <div class="label">当年用电：{{ yearElectricityUse }}</div>
            <div class="unit">kwh</div>
          </div>
          <div class="chart-row">
            <ElectricityHistogram :chartId="yearChart" :chartData="yearData"></ElectricityHistogram>
          </div>
        </div>
      </div>
      <div class="table-container" v-else>
        <el-table :data="chartTableData" style="width: 100%" max-height="300">
          <el-table-column label="序号" type="index" show-overflow-tooltip></el-table-column>
          <el-table-column prop="date" label="日期" show-overflow-tooltip></el-table-column>
          <el-table-column prop="buildName" label="建筑名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="use" label="总用电量(kwh)" show-overflow-tooltip></el-table-column>
          <el-table-column prop="pUse" label="高峰用电量(kwh)" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fFUse" label="平时电量(kwh)" show-overflow-tooltip></el-table-column>
          <el-table-column prop="vUse" label="低谷用电量(kwh)" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Dates } from "$utils";
import ElectricityHistogram from './ElectricityHistogram';
export default {
  name: 'EnergyStatistics',
  components: {
    ElectricityHistogram
  },
  data() {
    return {
      showChart: true,
      buildingData: '',
      dateType: '0',
      dayDate: Dates.format(new Date(), "yyyy-MM-dd"),
      buildingArr: [],
      dateTypeArr: [{ 'label': '日', 'value': '0' }, { 'label': '月', 'value': '1' }, { 'label': '年', 'value': '2' }],
      clearFlag: false,
      dayChart: 'dayChart',
      monthChart: 'monthChart',
      yearChart: 'yearChart',
      dayElectricityUse: 0,
      monthElectricityUse: 0,
      yearElectricityUse: 0,
      dayData: {
        xData: [],
        yDataA: [],
        yDataB: [],
        yDataC: [],
        yDataD: [],
      },
      monthData: {
        xData: [],
        yDataA: [],
        yDataB: [],
        yDataC: [],
        yDataD: [],
      },
      yearData: {
        xData: [],
        yDataA: [],
        yDataB: [],
        yDataC: [],
        yDataD: [],
      },
      chartTableData: []
    }
  },
  created() {
    this.queryBuildList()
    this.queryData()
  },
  methods: {
    async queryBuildList() {
      const { success, returnObj } = await this.$fetch("/bms/energyMeterInfo/getBuildList")
      if (success) {
        this.buildingArr = returnObj.map(v => {
          return {
            label: v.name,
            value: v.id
          }
        })
      }
    },
    changeBox() {
      this.showChart = !this.showChart
      if (this.showChart == false) {
        this.dateType = '0'
        this.dayDate = Dates.format(new Date(), "yyyy-MM-dd")
        this.queryData()
      } else {
        this.dayDate = Dates.format(new Date(), "yyyy-MM-dd")
        this.queryData()
      }
    },
    typeChange(data) {
      if (data == '0') {
        this.dayDate = Dates.format(new Date(), "yyyy-MM-dd")
        this.queryData()
      } else if (data == '1') {
        this.dayDate = Dates.format(new Date(), "yyyy-MM")
        this.queryData()
      } else if (data == '2') {
        this.dayDate = Dates.format(new Date(), "yyyy")
        this.queryData()
      }
    },
    async queryData() {
      if (this.showChart) {
        const {
          success,
          returnObj
        } = await this.$fetch('/bms/energyMeterDataInfo/energyConsumptionStatistics' + '?buildId=' + this.buildingData + '&date=' + this.dayDate)
        if (success) {
          if (returnObj) {
            this.dayElectricityUse = returnObj.dayUse
            this.monthElectricityUse = returnObj.monthUse
            this.yearElectricityUse = returnObj.yearUse
            let dateArr = this.dayDate.split('-')
            let month = dateArr[0] + '-' + dateArr[1]
            let year = dateArr[0]
            this.dayData = {
              xData: [this.dayDate],
              yDataA: [returnObj.dayUse],
              yDataB: [returnObj.dayPUse],
              yDataC: [returnObj.dayFUse],
              yDataD: [returnObj.dayVUse]
            }
            this.monthData = {
              xData: [month],
              yDataA: [returnObj.monthUse],
              yDataB: [returnObj.monthPUse],
              yDataC: [returnObj.monthFUse],
              yDataD: [returnObj.monthVUse]
            }
            this.yearData = {
              xData: [year],
              yDataA: [returnObj.yearUse],
              yDataB: [returnObj.yearPUse],
              yDataC: [returnObj.yearFUse],
              yDataD: [returnObj.yearVUse]
            }
          } else {
            this.dayElectricityUse = 0
            this.monthElectricityUse = 0
            this.yearElectricityUse = 0
            this.dayData = {
              xData: [],
              yDataA: [],
              yDataB: [],
              yDataC: [],
              yDataD: []
            }
            this.monthData = {
              xData: [],
              yDataA: [],
              yDataB: [],
              yDataC: [],
              yDataD: []
            }
            this.yearData = {
              xData: [],
              yDataA: [],
              yDataB: [],
              yDataC: [],
              yDataD: []
            }
          }
        }
      } else {
        const { success, returnObj } = await this.$fetch('/bms/energyMeterDataInfo/getVPFDataList' + '?buildId=' + this.buildingData + '&date=' + this.dayDate + '&type=' + this.dateType)
        if (success) {
          this.chartTableData = returnObj
        } else {
          this.chartTableData = []
        }
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.energy-statistics {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title {
    width: 100%;
    height: 38px;
    line-height: 38px;
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    padding: 0 10px;
  }

  .query-condition {
    display: flex;
    justify-content: flex-end;
    margin: 0 10px;

    .condition-row {
      display: flex;
      align-items: center;

      .label {
        margin: 0 10px;
      }
    }
  }

  .chart-box {
    flex: 1;
    margin: 20px 10px 0 10px;
    display: flex;

    .chart-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;

      .part {
        flex: 1;
        height: 100%;

        .total-row {
          width: 100%;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          .label {
            font-size: 16px;
          }

          .unit {
            margin-left: 5px;
          }
        }

        .chart-row {
          margin-top: 10%;
        }
      }
    }

    .table-container {
      flex: 1;
      overflow-y: auto;
    }
  }

  #show-text::after {
    content: "切换视图";
    display: none;
    position: absolute;
    padding: 8px;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
  }

  #show-text:hover::after {
    display: block;
  }
}
</style>